import Vue from 'vue';
import VeeValidate from 'vee-validate';
import id from 'vee-validate/dist/locale/id';

VeeValidate.Validator.localize('id', id);
Vue.use(VeeValidate, {
  locale: 'id',
});
